import React from "react";

import { PesajeListComponent } from "../components/Pesajes/PesajeListComponent";
import { PesajeListEditComponent } from "../components/Pesajes/PesajeListEditComponent";
import { PesajeComentarioEditComponent } from "../components/Pesajes/PesajeComentarioEditComponent";
import { PesajeEditComponent } from "../components/Pesajes/PesajeEditComponent";
import { PesajeCreateComponent } from "../components/Pesajes/PesajeCreateComponent_tpl";

export const PesajeList = props => (
  <PesajeListComponent {...props} />
);

export const PesajeListEdit = props => (
  <PesajeListEditComponent {...props} />
);

export const PesajeComentarioEdit = props => (
  <PesajeComentarioEditComponent {...props} />
);

export const PesajeEdit = props => {
  return (
    <PesajeEditComponent {...props} />
  );
};

export const PesajeCreate = props => {
  return (
    <PesajeCreateComponent {...props} />
  );
};



// WEBPACK FOOTER //
// ./src/services/pesajes.js